var React = require('react');

function SelectionRadioDisable (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"8","cy":"8","r":"7.5","fill":"#F2F3F3","fillRule":"evenodd","stroke":"#E5E7E8"}));
}

SelectionRadioDisable.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = SelectionRadioDisable;

SelectionRadioDisable.default = SelectionRadioDisable;
